/**
 * Contains components that are exported for use in ARCHIBUS
 */

import * as AbWorkflow from './workflow'

if (!window.rawReactComponents) {
  window.rawReactComponents = {}
}

// Override ARCHIBUS methods
Ab.data.DataSource.prototype.getRecordsAsync = function(restriction, config) {
  let me = this
  let parameters = this.getParameters(config)

  if (restriction) {
    if (restriction.addClauses) {
      restriction.addClauses(this.restriction, false)
    }
  } else {
    restriction = this.restriction
  }
  parameters.restriction = toJSON(restriction || {})
  parameters.recordLimit = this.recordLimit

  return AbWorkflow.call('AbCommonResources-getDataRecords', parameters).then(
    function(result) {
      let records = []
      for (let i = 0; i < result.dataSet.records.length; i++) {
        records.push(me.processInboundRecord(result.dataSet.records[i]))
      }
      return Promise.resolve(records)
    }
  )
}

Ab.data.DataSource.prototype.getDataSetAsync = function(restriction, config) {
  let me = this
  let parameters = this.getParameters(config)

  if (restriction) {
    if (restriction.addClauses) {
      restriction.addClauses(this.restriction, false)
    }
  } else {
    restriction = this.restriction
  }
  parameters.restriction = toJSON(restriction || {})
  parameters.recordLimit = this.recordLimit

  return AbWorkflow.call('AbCommonResources-getDataRecords', parameters).then(
    result => {
      let records = []
      let data = {}

      for (let i = 0; i < result.dataSet.records.length; i++) {
        records.push(me.processInboundRecord(result.dataSet.records[i]))
      }

      data.records = records

      if (result.data.totals) {
        let totals = new Ab.data.Record()
        totals.fromJSON(result.data.totals)
        let dataRecord = this.processInboundRecord(totals)
        data.totals = dataRecord.values
      }

      return Promise.resolve(data)
    }
  )
}
